import React from 'react';
import PropTypes from 'prop-types';


import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { MetaFormFragmentBase } from 'Components/UI/Meta/MetaForm/Components/MetaFormFragmentBase';
import { buildFacetDesignOverrideLite } from 'src/Packages/FacetRest/FacetDesignOverrideLite';

const defaultMetaOverrideSet = buildFacetDesignOverrideLite();

// MetaResourceRendererLite comes with a defaultMetaOverrideSet that imports fewer components than the
// defaultMetaOverrideSet that is defined in MetaResourceRenderer. This is desirable in the marketing
// app because we can avoid importing components that are not actually used by this bundle which
// allows esbuild to tree shake unused imports from FD.
export const MetaResourceRendererLite = ({
  metaOverrideSet,
  resource,
  layout,
  LayoutProps,
  onSubmit,
  onDelete,
  onFailure,
  onChange,
  confirmDeleteMessage,
  fieldsImmediatelyRequired,
  errors,
}) => {
  const { displayErrorMessage } = useSnackbarContext();
  return (
    <MetaFormInline
      LayoutProps={{
        hideErrorList: true, noExtraMarkup: true, onlyRenderLayout: true, ...LayoutProps,
      }}
      errorsOverride={errors}
      metaOverrideSet={metaOverrideSet}
      component={MetaFormFragmentBase}
      resource={resource}
      layout={layout}
      noIndividualSubmitButtons
      onChange={onChange}
      onSubmit={onSubmit}
      onDelete={onDelete}
      fieldsImmediatelyRequired={fieldsImmediatelyRequired}
      onFailure={(err) => {
        if (onFailure) {
          return onFailure(err, err.errors || 'An unexpected error has occurred.');
        }
        return displayErrorMessage(err, err.errors || 'An unexpected error has occurred.');
      }}
      confirmDeleteMessage={confirmDeleteMessage}
      noIndividualDeleteButtons
    />
  );
};

MetaResourceRendererLite.defaultProps = {
  metaOverrideSet: defaultMetaOverrideSet,
  onSubmit: () => {},
  onDelete: () => {},
  onChange: () => {},
  onFailure: undefined,
  confirmDeleteMessage: undefined,
  LayoutProps: {},
  fieldsImmediatelyRequired: false,
  errors: null,
};

MetaResourceRendererLite.propTypes = {
  metaOverrideSet: PropTypes.object,
  resource: PropTypes.object.isRequired,
  layout: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func,
  onChange: PropTypes.func,
  onFailure: PropTypes.func,
  confirmDeleteMessage: PropTypes.string,
  LayoutProps: PropTypes.object,
  fieldsImmediatelyRequired: PropTypes.bool,
  errors: PropTypes.array,
};
